$(() => {
    if ($('.block.form').length) {
        var form = $('.block.form');

        $('.gfield--type-address .ginput_container .gform-grid-col').each(function() {
            var field = $(this);
            var label = field.find('label');
            if (label.text() !== 'Street Address Line 2') {
                label.append('<span class="gfield_required"><span class="gfield_required gfield_required_asterisk">*</span></span>');
            }
        });
    }
})